import { render, staticRenderFns } from "./ResetPasswordSubmit.vue?vue&type=template&id=fa0b6e72&"
import script from "./ResetPasswordSubmit.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports